'use client';
import React from 'react';
import { styled } from '../stitches.config.js';
import { Flex } from './Flex.js';
import { CheckIcon } from '@radix-ui/react-icons';

const StyledVerifiedBadge = styled('div', Flex, {
    alignItems: 'center',
    backgroundColor: '$info9',
    borderRadius: '$round',
    color: '$loContrast',
    flexShrink: 0,
    justifyContent: 'center',
    width: '$3',
    height: '$3',
});
const VerifiedBadge = React.forwardRef((props, forwardedRef) => (React.createElement(StyledVerifiedBadge, Object.assign({}, props, { ref: forwardedRef }),
    React.createElement(CheckIcon, null))));

export { VerifiedBadge };
